
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Child',
    props: {
        msg: {
            type: String,
        }
    },
    setup(props,context) {
        console.log('Child--props--',props);
        console.log('Child--context--',context, (context as any).props.msg);
        return {

        }
    }
});
